import * as React from 'react';

// Context
import { RouteLoadingContext } from '@shopee/route-loading-context';

// Hooks
import { useTranslation } from '@shopee-user/platform';
import { useShouldHideBack } from '@shopee-user/with-web-view';

// Components
import { AuthBackgroundContainer } from '@shopee-user/business-customization-ui';
import { Navbar, PageLoading } from '@shopee-user/business-customization-ui';
import { HelpSpan } from '@shopee-user/business-customization-ui';

// Styles
import styles from './style.scss';

type Props = {
  isLoading?: boolean;
};

export default function PageSignup({ isLoading }: Props) {
  const shouldHideBack = useShouldHideBack();
  const I18n = useTranslation();
  return (
    <AuthBackgroundContainer className={styles.container}>
      <Navbar
        title={I18n.t('label_signup')}
        rightContent={<HelpSpan text={I18n.t('label_help')} />}
        onClickBack={() => undefined}
        shouldHideBack={shouldHideBack}
      />
      <RouteLoadingContext.Consumer>
        {({ showLoadingPlaceholder }) => {
          if (showLoadingPlaceholder || isLoading) {
            return <PageLoading />;
          } else {
            return null;
          }
        }}
      </RouteLoadingContext.Consumer>
    </AuthBackgroundContainer>
  );
}
